import { useFetchWrapper } from '_helpers';

export { useOneOnOneActions };

function useOneOnOneActions() {
    const fetchWrapper = useFetchWrapper();

    // Returns { records, overExcused } for staff; { records, overExcused:[] } for students.
    // Pass from/to (ISO) to scope to a date range (e.g. a calendar week) — cheaper: skips the
    // overExcused aggregation server-side, which only the 1:1 management page needs.
    async function getAll(from, to) {
        try {
            const qs = from || to ? `?${new URLSearchParams({ ...(from && { from }), ...(to && { to }) })}` : '';
            const res = await fetchWrapper.get(`/api/one-on-one${qs}`);
            const json = await res.json();
            if (json.status === 'Success') return json.message;
            return { records: [], overExcused: [] };
        } catch (e) {
            console.error('getAll 1:1:', e);
            return { records: [], overExcused: [] };
        }
    }

    async function create(fields) {
        const res = await fetchWrapper.post('/api/one-on-one', 'application/json', JSON.stringify(fields));
        return res.json();
    }

    async function update(id, fields) {
        const res = await fetchWrapper.put(`/api/one-on-one/${id}`, 'application/json', JSON.stringify(fields));
        return res.json();
    }

    async function remove(id) {
        const res = await fetchWrapper.delete(`/api/one-on-one/${id}`);
        return res.json();
    }

    return { getAll, create, update, remove };
}
